import { render, staticRenderFns } from "./PricingAdmin.vue?vue&type=template&id=0b271d88&scoped=true&"
import script from "./PricingAdmin.vue?vue&type=script&lang=js&"
export * from "./PricingAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PricingAdmin.vue?vue&type=style&index=0&id=0b271d88&prod&lang=css&"
import style1 from "./PricingAdmin.vue?vue&type=style&index=1&id=0b271d88&prod&scoped=true&lang=css&"
import style2 from "./PricingAdmin.vue?vue&type=style&index=2&id=0b271d88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b271d88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VBtn,VCard,VChip,VCol,VDivider,VIcon,VList,VListItem,VListItemContent,VListItemTitle,VMain,VRow,VTextField})
